import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { createUseStyles } from 'react-jss';

import { RegionType } from '../../../../types';
import RegionItems from './region-items';
import RegionLabel from './region-label';
import RegionProgress from './region-progress';

const useStyles = createUseStyles({
  region: {
    composes: ['mb3'],
  },
});

const RegionTrophiesComponent = React.memo(({ onClick, opened, region }) => {
  const { id, label, latlng } = region;
  const classes = useStyles();

  const clickHandler = useCallback(() => {
    onClick(id, latlng);
  }, [id, latlng, onClick]);

  const isopened = opened === id;
  return (
    <div
      className={classes.region}
      role="button"
      tabIndex={-1}
      onClick={clickHandler}>
      <RegionLabel label={label} />
      <RegionProgress id={id} />
      {isopened && <RegionItems id={id} />}
    </div>
  );
});

RegionTrophiesComponent.defaultProps = {
  opened: null,
};

RegionTrophiesComponent.propTypes = {
  onClick: PropTypes.func.isRequired,
  opened: PropTypes.string,
  region: RegionType.isRequired,
};

RegionTrophiesComponent.displayName = 'RegionTrophiesComponent';

export default RegionTrophiesComponent;
